const getColor = {
    methods: {
        getStatisticColors(item) {
            let active = ''

            const bad = '#FF3100' // less 21%
            const soSo = '#F07300' // less 41%
            const good = '#9BCD82' // 2less 61%
            const ok = '#FFC100' // less 81%
            const awesome = '#3493FF' // more 80%

            if (item <= 20) {
                active = bad
            } else if (item >= 20 && item <= 40) {
                active = soSo
            } else if (item >= 40 && item <= 60) {
                active = ok
            } else if (item >= 60 && item <= 80) {
                active = good
            } else if (item > 80) {
                active = awesome
            }

            return active
        },
    },
}

export default getColor
